export const ServiceStateText = {
  grantDriveStatus: 'GrantDriveは正常に稼働しています',
  boxApiStatus: 'Box APIサービスは正常に稼働しています',
  grantDriveStatusErr: 'GrantDriveに障害が発生しています',
  boxApiStatusErr: 'Box APIサービスに障害が発生しています',
};
